import { addWeeks, isFuture } from 'date-fns'

export const isNew = (createdAt: Date, newUntil = addWeeks(createdAt, 2)) => {
  return isFuture(newUntil)
}
